module.exports = __webpack_public_path__ + "img/default-img.539de99f.jpg";